export function handleError(err,name){
    // let message = err.message;
    // if(err.response.data.errors[0]['detail']){
    //     message = err.response.data.errors[0]['detail']
    // }else if(err.response.data.errors[0]['title']){
    //     message = err.response.data.errors[0]['title']
    // }
    // // alert(message)
    console.log(name, err)
}
